'use strict';

const FacebookPromNight = {
  init(payload, done) {
    $('.share-links .icon-facebook').on({
      click(e) {
        e.preventDefault();
        return window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            $(this).attr('href')
          )}`,
          '_blank',
          'width=626,height=436'
        );
      },
    });

    return done();
  },
};

module.exports = FacebookPromNight;
